import { render, staticRenderFns } from "./NewsFilePreview.vue?vue&type=template&id=7ef591da"
import script from "./NewsFilePreview.js?vue&type=script&lang=js&external"
export * from "./NewsFilePreview.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports